import { useNavigate } from "react-router-dom";
import { HiShieldExclamation, HiHome, HiArrowRight } from "react-icons/hi2";

export default function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center bg-slate-50 dark:bg-slate-900 px-4 py-8"
      dir="rtl"
    >
      <div className="w-full max-w-lg text-center">
      
        <div className="relative mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-2xl bg-[#690039]/10 dark:bg-[#690039]/20 shadow-inner">
          <HiShieldExclamation className="h-12 w-12 text-[#690039]" />
          <span className="absolute -bottom-2 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#690039] text-xs font-bold text-white shadow-md">
            403
          </span>
        </div>

     
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
          عدم دسترسی به این صفحه
        </h1>

        <p className="mt-3 text-sm sm:text-base text-slate-600 dark:text-slate-400 leading-relaxed max-w-md mx-auto">
          شما مجوز لازم برای مشاهده این بخش را ندارید. در صورتی که فکر می‌کنید این یک خطا است، با مدیر سیستم تماس بگیرید.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
  
          <button
            type="button"
            onClick={() => navigate("/")}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-xl bg-[#690039] hover:bg-[#52002c] active:bg-[#400022] px-6 py-2.5 text-sm font-medium text-white shadow-md shadow-[#690039]/20 transition-all duration-200 cursor-pointer"
          >
            <HiHome className="text-lg" />
            <span>بازگشت به داشبورد</span>
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-800/60 px-5 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200 shadow-sm hover:border-[#690039]/30 hover:text-[#690039] dark:hover:text-[#690039] transition-all duration-200 cursor-pointer"
          >
            <HiArrowRight className="text-lg" />
            <span>صفحه قبلی</span>
          </button>
        </div>
        <div className="mt-8 rounded-xl border border-slate-200 dark:border-slate-800 bg-white/70 dark:bg-slate-800/40 p-4 backdrop-blur-sm text-xs text-slate-500 dark:text-slate-400">
          کد خطا:{" "}
          <span className="font-mono font-bold text-[#690039] dark:text-[#a0125c]">
            FORBIDDEN_403
          </span>{" "}
          — سطح دسترسی حساب کاربری شما کافی نیست.
        </div>
      </div>
    </div>
  );
}
